module.exports = __webpack_public_path__ + "media/images/favicon-7e7ce1b01824f07e9976c78ae5594f22.ico";